import { ClearOutlined }       from '@ant-design/icons';
import { SearchOutlined }      from '@ant-design/icons';
import { Select }              from 'antd';
import { Button }              from 'antd';
import { Col }                 from 'antd';
import { Row }                 from 'antd';
import { Form }                from 'antd';
import { Slider }              from 'antd';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import YesOrNo                 from 'components/App/YesOrNo';
import StandModel              from 'models/StandModel';

const StandListMountingAttestationFilters = ({
  onSubmit,
}: {
  onSubmit: (filters: StandModel['filters']) => void;
}) => {
  const [form] = Form.useForm();

  return (
    <Form
      form={form}
      layout="vertical"
      name="top_table_filters"
      onFinish={values => {
        const finalValues: StandModel['filters'] = {
          'exists[mountingAttestations]': typeof values['exists[mountingAttestations]'] === 'boolean' ? values['exists[mountingAttestations]'] : undefined,
          'mountingAttestations.electricalPowerKva[gte]': values.electricalPowerKva ? values.electricalPowerKva[0] : undefined,
          'mountingAttestations.electricalPowerKva[lte]': values.electricalPowerKva ? values.electricalPowerKva[1] : undefined,
          'mountingAttestations.groundHeightCategory': values.groundHeightCategory,
          'mountingAttestations.suspendedEquipmentSecured': values.suspendedEquipmentSecured,
          'mountingAttestations.anchoring': undefined,
          'mountingAttestations.guying': undefined,
          'mountingAttestations.ballasting': undefined,
          'mountingAttestations.selfSupporting': undefined,
        };

        values.stability?.forEach((stability: 'anchoring' | 'guying' | 'ballasting' | 'selfSupporting') => {
          const key = `mountingAttestations.${stability}` as keyof StandModel['filters'];
          (finalValues as any)[key] = true;
        });

        onSubmit(finalValues);
      }}
    >
      <Row gutter={[16, 16]}>
        <Col md={4} sm={24}>
          <Form.Item
            label={<FormattedMessageWrapper id="Avec attestation" />}
            name="exists[mountingAttestations]"
          >
            <YesOrNo
              optionType="button"
            />
          </Form.Item>
        </Col>
        <Col md={4} sm={24}>
          <Form.Item
            label={<FormattedMessageWrapper id="Construction au sol" />}
            name="groundHeightCategory"
          >
            <Select
              allowClear
              placeholder={<FormattedMessageWrapper id="Construction au sol" />}
              size="large"
            >
              <Select.Option value="inf_350">
                <FormattedMessageWrapper id="Hauteur inférieure à 3.50m" />
              </Select.Option>
              <Select.Option value="sup_350">
                <FormattedMessageWrapper id="Hauteur supérieure à 3.50m" />
              </Select.Option>
            </Select>
          </Form.Item>
        </Col>
        <Col md={4} sm={24}>
          <Form.Item
            label={<FormattedMessageWrapper id="Stabilité" />}
            name="stability"
          >
            <Select
              allowClear
              mode="multiple"
              placeholder={<FormattedMessageWrapper id="Stabilité" />}
              size="large"
            >
              <Select.Option value="anchoring">
                <FormattedMessageWrapper id="Ancrage" />
              </Select.Option>
              <Select.Option value="guying">
                <FormattedMessageWrapper id="Haubenage" />
              </Select.Option>
              <Select.Option value="ballasting">
                <FormattedMessageWrapper id="Lestage" />
              </Select.Option>
              <Select.Option value="selfSupporting">
                <FormattedMessageWrapper id="Autoporté" />
              </Select.Option>
            </Select>
          </Form.Item>
        </Col>
        <Col md={4} sm={24}>
          <Form.Item
            label={<FormattedMessageWrapper id="Équipements suspendus" />}
            name="suspendedEquipmentSecured"
          >
            <YesOrNo
              optionType="button"
            />
          </Form.Item>
        </Col>
        <Col md={4} sm={24}>
          <Form.Item
            label={<FormattedMessageWrapper id="Puissance élec (kVA)" />}
            name="electricalPowerKva"
          >
            <Slider
              max={999}
              min={1}
              range
              style={{
                margin: '15px 0',
                width: 100
              }}
            />
          </Form.Item>
        </Col>
        <Col md={4} sm={24}>
          <Form.Item>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              <Button
                htmlType="submit"
                icon={<SearchOutlined />}
                size="large"
                style={{
                  alignItems: 'center',
                  display: 'flex',
                  gap: '8px',
                }}
                type="primary"
              >
                <FormattedMessageWrapper id="Rechercher" />
              </Button>
              <Button
                icon={<ClearOutlined />}
                onClick={() => {
                  form.resetFields();
                  form.submit();
                }}
                size="large"
                style={{
                  alignItems: 'center',
                  display: 'flex',
                  gap: '8px',
                }}
              >
                <FormattedMessageWrapper id="Effacer" />
              </Button>
            </div>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default StandListMountingAttestationFilters;